import { useEffect, useMemo, useState } from "react";
import PCNewsCard from "./PCNewsCard";
import PCRightPanel from "./PCRightPanel";

function TierRule() {
  return (
    <div style={{ padding: "4px 28px 0" }}>
      <div style={{ borderTop: "2px solid rgba(255,255,255,.6)" }} />
    </div>
  );
}

function groupByTier(arr) {
  return {
    gun:       arr.filter(a => a.cls === "gun"),
    watershed: arr.filter(a => a.cls === "watershed"),
    notable:   arr.filter(a => a.cls === "notable"),
    common:    arr.filter(a => !a.cls || a.cls === "common"),
  };
}

function badgeForItem(kind, item) {
  if (kind === "adversary") {
    return { label: item.flag || "ADV", color: "var(--pc-src-adversary)" };
  }
  return null;
}

function TieredList({ items, kind, selected, onSelect, onOverride }) {
  const byTier = useMemo(() => groupByTier(items || []), [items]);
  if (!items?.length) return null;

  const sections = [
    { key: "gun",       articles: byTier.gun },
    { key: "watershed", articles: byTier.watershed },
    { key: "notable",   articles: byTier.notable },
    { key: "common",    articles: byTier.common },
  ];

  let firstNonEmptyDone = false;
  return (
    <div>
      {sections.map((sec) => {
        if (sec.articles.length === 0) return null;
        const showRule = firstNonEmptyDone;
        firstNonEmptyDone = true;
        return (
          <div key={sec.key}>
            {showRule && <TierRule />}
            {sec.articles.map(a => (
              <PCNewsCard
                key={a.id}
                article={a}
                selected={selected?.id === a.id}
                onClick={onSelect}
                onOverride={onOverride}
                kindBadge={badgeForItem(kind, a)}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
}

export default function PCUnverifiedTab({
  socmint, adversary,
  unverifiedPanel, setUnverifiedPanel,
  onOverride,
}) {
  const [sub, setSub] = useState(unverifiedPanel || "socmint");
  const items = sub === "socmint" ? (socmint || []) : (adversary || []);
  const [selected, setSelected] = useState(null);

  // Reset selection when sub changes
  useEffect(() => { setSelected(null); }, [sub]);
  useEffect(() => { setUnverifiedPanel && setUnverifiedPanel(sub); }, [sub]); // eslint-disable-line

  return (
    <div style={{ flex: 1, display: "flex", overflow: "hidden", minHeight: 0 }}>
      {/* Left column: sub-tabs + tier-grouped list */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>
        <div style={{ display: "flex", borderBottom: "1px solid var(--pc-line-3)", flexShrink: 0, background: "var(--pc-bg-1)" }}>
          {[["socmint", "Rumor"], ["adversary", "Adversary News"]].map(([id, label]) => {
            const on = sub === id;
            return (
              <button
                key={id}
                onClick={() => setSub(id)}
                style={{
                  flex: 1, minHeight: 42, background: "none", border: "none", cursor: "pointer",
                  fontSize: 12, letterSpacing: ".18em", textTransform: "uppercase",
                  color: on ? "var(--pc-fg-1)" : "var(--pc-fg-3)",
                  fontWeight: on ? 700 : 400,
                  borderBottom: `2px solid ${on ? "rgba(255,255,255,.6)" : "transparent"}`,
                  marginBottom: -1,
                  fontFamily: "var(--pc-font-sans)",
                }}
              >{label}</button>
            );
          })}
        </div>

        <div style={{ flex: 1, overflowY: "auto" }}>
          {items.length === 0 ? (
            <div style={{ padding: 60, textAlign: "center", color: "var(--pc-fg-3)", fontSize: 12 }}>
              {sub === "socmint" ? "OSINT 텔레그램 보도 없음" : "적대국 매체 보도 없음"}
            </div>
          ) : (
            <TieredList
              items={items}
              kind={sub}
              selected={selected}
              onSelect={setSelected}
              onOverride={onOverride}
            />
          )}
        </div>
      </div>

      {/* Right panel: same shell as NewsTab — full analysis */}
      <PCRightPanel
        article={selected}
        allArticles={items}
        adversaryArticles={sub === "adversary" ? items : (adversary || [])}
        onSelect={setSelected}
      />
    </div>
  );
}
